import { ADD_RULE, CLEAR_RULE, PATCH_RULES, SET_RULES, SET_RULES_LOADING } from '../constants';

// List-cache for the Rules table — deliberately minimal compared to
// reducers/campaigns.js (no pagination/filter state yet; add it here once
// pages/rules/Rules.js actually needs it).
const initialState = {
  rules: undefined,
  loading: true,
};

export const rulesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RULES_LOADING:
      return { ...state, loading: true };
    case SET_RULES:
      return { ...state, rules: action?.payload, loading: false };
    case ADD_RULE:
      return {
        ...state,
        rules: state.rules ? [action?.payload, ...state.rules] : [action?.payload],
        loading: false,
      };
    case CLEAR_RULE:
      return { rules: undefined, loading: true };
    // Optimistic local patch — RulesTable.js's bulk activate/deactivate
    // dispatches this synchronously on click (before the PUT even lands) so
    // the Status cell flips to "Calculating" the instant the button is
    // pressed instead of waiting a full round trip + refetch to show
    // anything happened. `payload` is keyed by rule id: { [id]: { status?,
    // processingStatus? } }. The real values land moments later from the
    // API response / Rules.js's processing-poll, which just overwrite this.
    case PATCH_RULES:
      return {
        ...state,
        rules: (state.rules ?? []).map((rule) => {
          const patch = action.payload?.[rule.id];
          if (!patch) return rule;
          return {
            ...rule,
            ...(patch.status ? { status: patch.status } : {}),
            full: rule.full ? { ...rule.full, ...patch } : rule.full,
          };
        }),
      };
    default:
      return state;
  }
};
